import { dateOptionalFromJSONValue, stringFromJSONValue } from './parser'

export class IncidentNarrativeItemModel {
  public dateTime: Date
  public text: string
  public author: string
  public type: string

  public constructor(dateTime: Date, text: string, author: string, type: string) {
    this.dateTime = dateTime
    this.text = text
    this.author = author
    this.type = type
  }

  public static modelFromJSON(json: any): IncidentNarrativeItemModel {
    return new IncidentNarrativeItemModel(
      dateOptionalFromJSONValue(json['NarrativeDateTime']) ?? new Date(),
      stringFromJSONValue(json['NarrativeText']),
      stringFromJSONValue(json['NarrativeEntryBy']),
      stringFromJSONValue(json['NarrativeEntryType'])
    )
  }

  public formattedDateTime(timeZone: string) {
    const dateFormatter = new Intl.DateTimeFormat(undefined, {
      timeZone: timeZone,
      timeStyle: 'long',
      hour12: true
    })
    return dateFormatter.format(this.dateTime)
  }
}
